
import Vue from 'vue'
import LoadMore from './components/LoadMore.vue'
import Filters from './components/Filters.vue'
import Events from './components/Events.vue'
import SearchInfo from './components/SearchInfo.vue'
import Loader from './components/Loader.vue'

export default Vue.extend({
	name: 'app',
	components: {
		Filters,
		Events,
		LoadMore,
		SearchInfo,
		Loader
	}
})
